export const createLabelMapFromFieldNames = (fieldNamesAndLabels: any[]) => {
  return fieldNamesAndLabels.reduce((acc, field) => {
    acc[field.name] = field.label;

    return acc;
  }, {});
};
